const prefix = '@cart';

export const ITEMS_UPDATE = `${prefix}/ITEMS_UPDATE`;
export const ADD_TO_CART_SUCCESS = `${prefix}/ADD_TO_CART_SUCCESS`;

export const FETCH_ITEMS_REQUEST = `${prefix}/FETCH_ITEMS_REQUEST`;
export const FETCH_ITEMS_SUCCESS = `${prefix}/FETCH_ITEMS_SUCCESS`;
export const FETCH_ITEMS_FAILURE = `${prefix}/FETCH_ITEMS_FAILURE`;

export const CLEAR_REQUEST = `${prefix}/CLEAR_REQUEST`;
export const CLEAR_SUCCESS = `${prefix}/CLEAR_SUCCESS`;
export const CLEAR_FAILURE = `${prefix}/CLEAR_FAILURE`;

export const UPDATE_ITEM_REQUEST = `${prefix}/UPDATE_ITEM_REQUEST`;
export const UPDATE_ITEM_SUCCESS = `${prefix}/UPDATE_ITEM_SUCCESS`;
export const UPDATE_ITEM_FAILURE = `${prefix}/UPDATE_ITEM_FAILURE`;

export const REMOVE_ITEM_REQUEST = `${prefix}/REMOVE_ITEM_REQUEST`;
export const REMOVE_ITEM_SUCCESS = `${prefix}/REMOVE_ITEM_SUCCESS`;
export const REMOVE_ITEM_FAILURE = `${prefix}/REMOVE_ITEM_FAILURE`;

export const ADD_SAILPLAY_DISCOUNT_REQUEST = `${prefix}/ADD_SAILPLAY_DISCOUNT_REQUEST`;
export const ADD_SAILPLAY_DISCOUNT_SUCCESS = `${prefix}/ADD_SAILPLAY_DISCOUNT_SUCCESS`;
export const ADD_SAILPLAY_DISCOUNT_FAILURE = `${prefix}/ADD_SAILPLAY_DISCOUNT_FAILURE`;
export const CHANGE_CART_SAILPLAY_DISCOUNT_REQUEST = `${prefix}/CHANGE_CART_SAILPLAY_DISCOUNT_REQUEST`;
export const CHANGE_CART_SAILPLAY_DISCOUNT_SUCCESS = `${prefix}/CHANGE_CART_SAILPLAY_DISCOUNT_SUCCESS`;
export const CHANGE_CART_SAILPLAY_DISCOUNT_FAILURE = `${prefix}/CHANGE_CART_SAILPLAY_DISCOUNT_FAILURE`;

export const RESET_CART_STATE = `${prefix}/RESET_CART_STATE`;
